<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-title>{{ 'Terminal Device' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()" fill="clear">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<div class="inner-content">
  <ion-item class="bg-light">
    <ion-label position="stacked">{{ 'Terminal Device' | translate }}</ion-label>
    <ion-input [placeholder]="'xxx-xxx-xxx' | translate" [(ngModel)]="cardNumber"></ion-input>
  </ion-item>
</div>

<ion-footer class="px-3 py-2">
  <ion-button fill="solid" expand="block" type="submit" [disabled]="!cardNumber" (click)="save()">{{ 'Save' | translate }}</ion-button>
</ion-footer>